import { Component, AfterViewChecked, Output, Input, EventEmitter, ViewChild, ElementRef, OnDestroy  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as L from 'leaflet';
import { AdvancedHeatmapLayer } from 'leaflet-advanced-heatmap'
import "../../../../node_modules/leaflet-draw/dist/leaflet.draw.js";
import 'esri-leaflet-renderers';
//import "../../../../node_modules/esri-leaflet/dist/esri-leaflet.js";
//import 'esri-leaflet';
//import 'leaflet.timeline';
//import 'moment/moment';

import * as esri from 'esri-leaflet';
import * as v from 'esri-leaflet-vector';

import { SharedSeries } from 'src/app/models/dashboard';
import { IconService } from 'src/service/icon.service';

import { SearchItem } from '../../../api/models/search-item';
import { DataService } from '../../../api/services';
import { features } from 'process';
import { timestamp } from 'rxjs';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconShadowRetinaUrl = 'assets/marker-shadow.png';
const iconSelectedRetinaUrl = 'assets/marker-selected-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const selectedIconUrl = 'assets/marker-selected-icon.png';

//var moment = require('moment/moment');

@Component({
  selector: 'open-street-map',
  templateUrl: './open-street-map.component.html',
  styleUrls: ['./open-street-map.component.css']
})
// https://www.digitalocean.com/community/tutorials/angular-angular-and-leaflet
export class OpenStreetMapComponent implements AfterViewChecked, OnDestroy  {
  private map: L.map;

  @ViewChild('map', {static: true}) protected mapDivRef: ElementRef;
  protected mapDiv: HTMLDivElement;

  @Output() leftClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() onHover: EventEmitter<string> = new EventEmitter<string>();
  @Output() onUnhover: EventEmitter<string> = new EventEmitter<string>();
  @Input() mapheight: string;
  @Input() mapType: string;
  @Input() geoJson: string[];
  @Input() shapes: string[];

  //public pins: any;
  public defaultIcon: L.icon;// = icons.blue;
  public selectedIcon: L.icon;// = icons.blueSelected;

  
  tiles: L.tileLayer;
  googleTerrain: L.tileLayer;
  googleStreets: L.tileLayer;
  googleSat: L.tileLayer;
  lastLayer: L.tileLayer;

  shape: L.FeatureGroup;

  datalayers: any = {};
  trackers: any = {};
  trackerPoints: any = {};
  heatmaps: any = {};
  staticsites: any = {};
  geojsonitems: any = {};

  public changeLayer(layer: L.tileLayer){
    if (this.lastLayer){
      this.map.removeLayer(this.lastLayer);
    }
    layer.addTo(this.map);
    this.lastLayer = layer;
  }

  constructor(public icons: IconService, private http: HttpClient, private data: DataService) {
    icons.getPins(pins => {
      this.defaultIcon = pins["blueSelected"];
      this.selectedIcon = pins["blue"];
      
      L.Icon.Default.prototype.options.iconUrl = this.defaultIcon.options.iconUrl;
      L.Icon.Default.prototype.options.iconRetinaUrl = this.defaultIcon.options.iconRetinaUrl;
      L.Icon.Default.prototype.options.shadowUrl = this.defaultIcon.options.shadowUrl;
      L.Icon.Default.prototype.options.shadowRetinaUrl = this.defaultIcon.options.shadowRetinaUrl;
    });    
   }

  ngAfterViewChecked(): void {
    this.initMap();
  }

  ngOnDestroy(): void {
    console.log("Map Destroy");
      if (this.map){
        this.map.off();
        this.map.remove();
        this.map = null;
      }
  }

  public redraw(){
    setTimeout(() => {
      this.map.invalidateSize();
      if (this.resultGroup){
        this.map.fitBounds(this.resultGroup.getBounds());
      }
    }, 50);
  }

  public clearShape(){
    if (this.shape){
      this.map.removeLayer(this.shape);
    }
  }

  public stopEdit() {
    this.map.removeControl(this.drawControl);
  }

  public getShape() : any[] {
    var shapes = [];
    this.shape.eachLayer(function(layer) {
      try {
        shapes.push(layer.toGeoJSON());
      }
      catch (e){
        console.error(e);
      }
    });
    return shapes;
  }

  drawControl: L.Control.drawControl;
  public startEdit(){
    if (this.shape){
      this.map.removeLayer(this.shape);
    }
    this.shape = new L.FeatureGroup();
    this.map.addLayer(this.shape);

    const drawPluginOptions = {
      position: 'topright',
      draw: {
        polygon: {
          allowIntersection: false, // Restricts shapes to simple polygons
          drawError: {
            color: '#e1e100', // Color the shape will turn when intersects
            message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
          },
          shapeOptions: {
            color: '#97009c',
            fillOpacity: 0.05
          },
          showLength: true,
          metric: true
        },
        // disable toolbar item by setting it to false
        polyline: false,
        circlemarker: false, // Turns off this drawing tool
        circle: false, // Turns off this drawing tool
        rectangle: false,
        marker: true,
      },
      edit: { 
        featureGroup: this.shape, //REQUIRED!!
        remove: true
      }
    };
    
    this.drawControl = new L.Control.Draw(drawPluginOptions);
    this.map.addControl(this.drawControl);

    if (this.shapes){
      for (let shape of this.shapes){
        var shapes = JSON.parse(shape);
        try {
          //var layer = L.geoJSON(shapes);
          //layer.eachLayer(l => this.shape.addLayer(layer));
          var layer = L.geoJson(shapes, {
            onEachFeature: (feature, layer) => {
                this.shape.addLayer(layer);
            }, style: feature => {
              return { fillOpacity: 0.05 }
            }
          });
          this.map.addLayer(this.shape);
          //layer.addTo(this.map);          
        }
        catch (e) {
          console.log('Adding corrupt layer failed', e);
        }
      }
      //this.map.fitBounds(this.shape.getBounds());
    }

    this.map.on('draw:created', (e) => {
      var type = e.layerType,
        layer = e.layer;

      if (type === 'marker') {
        layer.bindPopup('A popup!');
      }
      //this.shapeItem.value = e.layer.getLatLngs();
      this.shape.addLayer(layer);
    });
  }
  


  private init: boolean;
  public initMap(): void {
    if (this.init){
      return;
    }
    this.init = true;
    if (this.map == null){
      console.log("Map Init");
      this.map = L.map(this.mapDivRef.nativeElement, {
        center: [ -42.026167, 146.708500 ],
        zoom: 3,
        zoomControl: false
      });
      L.control.zoom({
        position: 'bottomright'
      }).addTo(this.map);
      this.mapDiv = this.mapDivRef.nativeElement;
      this.mapDiv.style.height = this.mapheight;
    
  
      this.tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      });
      this.googleTerrain = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
        maxZoom: 20,
        subdomains:['mt0','mt1','mt2','mt3']
      });
      this.googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
        maxZoom: 20,
        subdomains:['mt0','mt1','mt2','mt3']
      });
      this.googleSat = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
        maxZoom: 20,
        subdomains:['mt0','mt1','mt2','mt3']
      });

      if (this.mapType == null ||  this.mapType == "googleTerrain"){
        this.changeLayer(this.googleTerrain);
      } else if (this.mapType == "googleStreets"){
        this.changeLayer(this.googleStreets);
      } else if (this.mapType == "googleSat"){
        this.changeLayer(this.googleSat);
      } else {
        this.changeLayer(this.tiles);
      }

     /* const apiKey = "AAPK5012cb2c1d1e4c8d967f167f4e758d17P27h4A1K3lxWJLLgGBkQBFbQfuhXv_nTeTead0DfM_MEcBqQ_eJWOaJObDv01neS";
              const basemapEnum = "arcgis/streets";
              var trailheads = esri
                .featureLayer({
                  url: "https://services.arcgis.com/rOo16HdIMeOBI4Mb/arcgis/rest/services/Heritage_Trees_Portland/FeatureServer/0"
                });

              trailheads.addTo(this.map);

              var trails = esri
                .featureLayer({
                  url: "https://services3.arcgis.com/GVgbJbqm8hXASVYi/arcgis/rest/services/Trails_Styled/FeatureServer/0"
                });

              trails.addTo(this.map);

              var parks = esri
                .featureLayer({
                  url: "https://services3.arcgis.com/GVgbJbqm8hXASVYi/arcgis/rest/services/Parks_and_Open_Space_Styled/FeatureServer/0"
                });

              parks.addTo(this.map);*/

      //const windyApiKey = 'H8VWqP8TwfX1rGgYwECBFcf81QeZ9OUv';
      
      /*const apiKey = "AAPK5012cb2c1d1e4c8d967f167f4e758d17P27h4A1K3lxWJLLgGBkQBFbQfuhXv_nTeTead0DfM_MEcBqQ_eJWOaJObDv01neS";
      const basemapEnum = "arcgis/streets";
      esri.basemapLayer('Streets', {
        apiKey: apiKey
      }).addTo(this.map);*/
      /*L.esri.Vector.vectorBasemapLayer(basemapEnum, {
        apiKey: apiKey
      }).addTo(this.map);*/
      /*var trailheads = L.esri
        .featureLayer({
          url: "https://services3.arcgis.com/GVgbJbqm8hXASVYi/arcgis/rest/services/Trailheads_Styled/FeatureServer/0"
        });
        trailheads.addTo(this.map)*/

      if (this.geoJson){
        var i = 0;
        for (var geoJson of this.geoJson){
          i++;
          this.loadGeoJson('map-' + i, this.geoJson, null);
        }
      }

      if (this.shape){
        this.map.removeLayer(this.shape);
      }
      this.shape = new L.FeatureGroup();
      this.map.addLayer(this.shape);
      if (this.shapes){
        for (let shape of this.shapes){

          var shapes = JSON.parse(shape);
          try {
            var layer = L.geoJSON(shapes);
  
            layer.addTo(this.map);
            this.shape.addLayer(layer);
          }
          catch (e) {
            console.error('Adding corrupt layer failed', e);
          }
        }
        //this.map.fitBounds(this.shape.getBounds());
      }
    }
  }

  public loadTracker(uri, values, colour, type){
    var tracker = null;
    var fitBounds = true;
    if (this.trackers && this.trackers[uri] != null){
      tracker = this.trackers[uri];
      if (Array.isArray(tracker)){
        for (let point of tracker){
          this.map.removeLayer(point);
        }
      } else {
        this.map.removeLayer(tracker);
        if (tracker.marker){
          tracker.marker.remove();
        }
      }
    }
    if (type == "tracker"){
      var path = [];
      for (let tsv of values){
          var coordinate = tsv.coordinate;
          if (coordinate && coordinate.latitude && coordinate.longitude){
            path.push([coordinate.latitude,coordinate.longitude]);
            //path.push([coordinate.Longitude,coordinate.Lattitude]);
          }
      }
      if (path.length > 1){
        var polyline = L.polyline(path, {color: colour}).addTo(this.map);
        this.trackers[uri] = polyline;
        if (fitBounds){
          this.map.fitBounds(polyline.getBounds());
        }
        var last = path[path.length-1];
        var marker = L.marker([last[1],last[0]],{icon:this.icons.pins.blue}).addTo(this.map);
        polyline.marker = marker;
      }
    } else {
      var points = [];
      for (let tsv of values){
        var coordinate = tsv.coordinate;
        if (coordinate && coordinate.latitude && coordinate.longitude){
          var radius = 1;
          if (type == "speed"){
            radius = Math.max(tsv.coordinate.speed, 1) * 3;
          }
          else if (type == "signal"){
            radius = Math.max(130 + tsv.coordinate.rssi, 1) * 3;
          }
          var point = L.circle([coordinate.latitude,coordinate.longitude], {radius: radius, color: colour});//.addTo(this.map);
          points.push(point);

          var pop = "<table>";
          if (tsv.coordinate.speed) pop += `<tr><td>Speed: </td><td>${tsv.coordinate.speed} km/h</td></tr>`;
          if (tsv.coordinate.rssi) pop += `<tr><td>RSSI: </td><td> ${tsv.coordinate.rssi} dB</td></tr>`;
          if (tsv.coordinate.direction) pop += `<tr><td>Heading: </td><td> ${tsv.coordinate.direction}°</td></tr>`;
          if (tsv.coordinate.altitude) pop += `<tr><td>Altitude: </td><td> ${tsv.coordinate.altitude} m</td></tr>`;
          if (tsv.coordinate.accuracy) pop += `<tr><td>Accuracy: </td><td> ${tsv.coordinate.accuracy}</td></tr>`;
          pop += "</table>";
          point.bindPopup(pop);         
        }
      }
      var resultGroup = L.featureGroup(points).addTo(this.map);
      var dataGroup = L.featureGroup();
      dataGroup.addLayer(resultGroup);
      try{
        this.map.fitBounds(dataGroup.getBounds());
      }
      catch{

      }
      
      this.trackers[uri] = resultGroup;
    }
  }

  public loadHeatmap(uri, values, colour, weight, useRssi = false){
    var tracker = null;
    var fitBounds = true;
    if (this.heatmaps && this.heatmaps[uri] != null){
      tracker = this.heatmaps[uri];
      this.map.removeLayer(tracker);
      if (tracker.marker){
        tracker.marker.remove();
      }
    }
    var path = [];
    for (let tsv of values){
      var coordinate = tsv.coordinate;
      if (coordinate && coordinate.latitude && coordinate.longitude){
        if(!useRssi)
        {
          path.push([coordinate.latitude,coordinate.longitude,weight]);
        }
        else
        {
          if(coordinate.rssi)
          {
            var newWeight = (1 / Math.abs(coordinate.rssi)) * weight;
            console.log("new weight is:", newWeight);
            path.push([coordinate.latitude,coordinate.longitude,newWeight]);
          }
          else
          {
            var newWeight = 1;
            path.push([coordinate.latitude,coordinate.longitude,newWeight]);
          }
        }
        
      }
    }
    if (path.length > 0){
      var heat = new AdvancedHeatmapLayer(path, {
        heatmap: {
          smooth: 0.1
        }
      }).addTo(this.map)
      const polygonMap = L.polygon(path)
      this.heatmaps[uri] = heat;
      if (fitBounds){
        this.dataGroup.addLayer(polygonMap);
        this.map.fitBounds(this.dataGroup.getBounds());
      }
    }
    
  }

  public loadLinkLayerContent(type, json){
    if (type == "geojson"){
            var datalayer = L.geoJson(json, 
        {
          pointToLayer: function (feature, latlng) {
            if (feature && feature.properties && feature.properties.type && feature.properties.type.eventIcon){
              //var popup = feature.properties.bodyHtml;
              //featureLayer.bindPopup(popup);
              
              //console.log(feature.properties.type);
              var type = feature.properties.alertLevel;
              var icon = feature.properties.type.eventIcon;
              var iconUrl = '/assets/icons/' + icon + ".svg";
              if (type == "emergency_warning"){
                var iconUrl = '/assets/icons/' + icon + "_red.svg";
              }
              if (type == "watch_and_act"){
                var iconUrl = '/assets/icons/' + icon + "_orange.svg";
              }
              if (type == "advice"){
                var iconUrl = '/assets/icons/' + icon + "_yellow.svg";
              }

              /*if (feature.properties.burntAreaGeometry){

              }*/

              var marker = L.marker(latlng, {icon:L.icon({iconUrl:iconUrl,iconSize:[38, 95]})});
              
              return marker;
            }
            else if (feature && feature.properties && feature.properties.style) {
              var style = feature.properties.style;
              return L.circleMarker(latlng, {
                radius: 8,
                fillOpacity: 0.85,
                weight: 1, // border weight
                ...style // Apply the dynamic color and fillColor
              });
            }
          },
          onEachFeature: function (feature, layer) {
            const props = feature.properties;

            // --- SOLUTION ---
            // Define a "blacklist" of keys you always want to ignore
            const keysToSkip = ['style']; 
            // You could easily add more, e.g.: ['style', 'id', 'internal_ref']
            // ---

            const contentLines = Object.entries(props)
                .filter(([key, value]) => {
                    // Conditions to KEEP an item:
                    // 1. Value is not null/undefined
                    // 2. The key is NOT in our 'keysToSkip' array
                    return value !== null && 
                           value !== undefined && 
                           !keysToSkip.includes(key); // <-- Checks the array
                })
                .map(([key, value]) => {
                    let displayValue = value;

                    // Handle values that are objects (but not arrays)
                    if (typeof value === 'object' && !Array.isArray(value)) {
                        displayValue = '[Object]'; 
                    }
                    
                    // Simple formatting: Bold the key
                    return `<b>${key}</b>: ${displayValue}`;
                });
            
            const tooltipContent = contentLines.join('<br>');
            if (tooltipContent != '<br>'){layer.bindTooltip(tooltipContent);}
            
          },
        }).addTo(this.map);
      return datalayer;
    } else if (type == "esri"){
                         
      var datalayer = esri.featureLayer({url:json});//.addTo(this.map);
      datalayer.addTo(this.map);
              
      return datalayer;
    } else {
      console.error("Unsupported Layer Type: " + type);
    }
    //todo: add KML
  }

  linkLayers:any = {};
  public loadLinkLayer(name, visible, direct, type, url){
    //todo: use the 'type' to load the layer the correct way.
    
    try{
      this.linkLayers[name] = {visible: visible, direct: direct, url: url, layer: null, type: type, error: false};
      if (visible){
        if (type == "esri"){
          var datalayer = this.loadLinkLayerContent(type, url);
          this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, layer: datalayer};
        } else {
          if (direct){
            this.http.get(url).subscribe(json => {
              var datalayer = this.loadLinkLayerContent(type, json);
              this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type,layer: datalayer};
            }, err => {
              this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
            });
          } else {
            this.data.DataProxy(url).subscribe(resp => {
                var json = JSON.parse(resp);
                var datalayer = this.loadLinkLayerContent(type, json);
                this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, layer: datalayer};
              }, err => {
                this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, error: true};
              });
          } 
        }
      } else {
        this.linkLayers[name] = {visible: visible, direct: direct, url: url, type: type, layer: null};
      }
    }
    catch{
      
    }
  }

  public showLinkLayer(layer){
    if (this.linkLayers[layer].visible){
      // remove layer
      var dl = this.linkLayers[layer].layer
      this.linkLayers[layer].visible = false;
      if (dl){
        this.map.removeLayer(dl);
      }
    }else{
      // show layer
      var ld = this.linkLayers[layer];
      this.loadLinkLayer(layer, !ld.visible, ld.direct, ld.type, ld.url);
    }
  }

  public loadGeoJson(uri, geoJson, colour) : boolean {
    try
    {
      if (typeof geoJson == 'number'){
        console.log('Could not load number as geojson');
        return false;
      }

      if (typeof geoJson == 'string'){
        geoJson = JSON.parse(geoJson);
      }

      if (geoJson.features == null){
        return false;
      }

      var fitBounds = true;
      var datalayer = null;
      if (this.datalayers && this.datalayers[uri] != null){
        datalayer = this.datalayers[uri];
        this.map.removeLayer(datalayer);
        fitBounds = false;
        if (datalayer.marker){
          datalayer.marker.remove();
          //this.map.removeMarker(datalayer.marker);
        }
      }

      datalayer = L.geoJson(geoJson ,{
        onEachFeature: function(feature, featureLayer) {
          if (feature && feature.properties){
            var popup = "<h3>" + feature.properties.name + "</h3>";
            if (feature.properties.timeStamp) popup += "<div><b>Time:</b> " + feature.properties.timeStamp + "</div>";
            if (feature.properties.speedKmph) popup += "<div><b>Speed:</b> " + feature.properties.speedKmph + " km/h</div>";
            if (feature.properties.headingDeg) popup += "<div><b>Heading:</b> " + feature.properties.headingDeg + "&#176;</div>";
            featureLayer.bindPopup(popup);
          }
        },
        pointToLayer: function(feature, latlng)  {
          var geojsonMarkerOptions = {
            radius: 8,
            fillColor: colour,
            color: "#000",
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8
          };
          //debugger;
          if (feature && feature.properties && feature.properties.opacity){
            geojsonMarkerOptions.fillOpacity = feature.properties.opacity;
            geojsonMarkerOptions.radius = (8 * feature.properties.opacity) + 1;
          }
          
          return L.circleMarker(latlng, geojsonMarkerOptions);
        },
        style: function(){
          return { color: colour }
        }
      }).addTo(this.map);
      
      if (fitBounds){
        //this.map.fitBounds(datalayer.getBounds());
        this.dataGroup.addLayer(datalayer);
        this.map.fitBounds(this.dataGroup.getBounds());
      }

      try {;
        var feature = geoJson.features[geoJson.features.length - 1];
        var coordinates = feature.geometry.coordinates;
        var last = geoJson.features.length == 1 ? coordinates[coordinates.length - 1] : coordinates;
        var geojsonMarkerOptions = {
          radius: 10,
          fillColor: "#aa78aa",
          color: "#000",
          weight: 1,
          opacity: 1,
          fillOpacity: 0.8
        };
        //var marker = L.marker([140,-42],{icon:iconDefault}).addTo(this.map);
        // invert the coordinates
        var marker = L.marker([last[1],last[0]],{icon:this.icons.pins.blue}).addTo(this.map);
        datalayer.marker = marker;
      }
      catch {
        console.log("Failed to find the latest point");
      }

      this.datalayers[uri] = datalayer;
    }
    catch (e) {
      console.error("Failed to load GeoJson", e);
    }
    return true;
  }

  private getPin(keyName:string): any{
    var pin = this.icons.pins[keyName];
    if (pin != null) return pin;
    return this.defaultIcon;
  }

  public loadStaticSite(uri: string, data: SharedSeries, colour: string, zoom: number, timeSeries, onClick){
    if (data.latitude && data.longitude){     
      var latest = data != null && data.values != null && data.values.length > 0 ? data.values[data.values.length - 1] : null;
      var pin = this.defaultIcon;
      var showValue = false;
      var geolist = this.geojsonitems[uri];
      if (geolist == null){
        geolist = [];
        this.geojsonitems[uri] = geolist;
      }
      var index = 0;
      if (latest){
        if (timeSeries.events){
          for (let event of timeSeries.events){
            event.index = index;
            var evt = geolist[event.index];
            if (evt == null){
              evt = {};
              geolist.push(evt);
            }
            if (event.check && event.match != null){
              var showGeoJson = false;
              if (event.check == "lessThan"){
                if (latest.value < event.match != null){
                  if (event.type == "pin") pin = this.getPin(event.pin);
                  if (event.type == "display") showValue = true;
                  if (event.type == "geojson") showGeoJson = true;
                }
              } else if (event.check == "lessThanEqual"){
                if (latest.value <= event.match){
                  if (event.type == "pin") pin = this.getPin(event.pin);
                  if (event.type == "display") showValue = true;
                  if (event.type == "geojson") showGeoJson = true;
                }
              } else if (event.check == "greaterThan"){
                if (latest.value > event.match){
                  if (event.type == "pin") pin = this.getPin(event.pin);
                  if (event.type == "display") showValue = true;
                  if (event.type == "geojson") showGeoJson = true;
                }
              } else if (event.check == "greaterThanEqual"){
                if (latest.value >= event.match){
                  if (event.type == "pin") pin = this.getPin(event.pin);
                  if (event.type == "display") showValue = true;
                  if (event.type == "geojson") showGeoJson = true;
                }
              } else if (event.check == "equal"){
                if (latest.value == event.match){
                  if (event.type == "pin") pin = this.getPin(event.pin);
                  if (event.type == "display") showValue = true;
                  if (event.type == "geojson") showGeoJson = true;
                }
              } else if (event.check == "notEqual"){
                if (latest.value != event.match){
                  if (event.type == "pin") pin = this.getPin(event.pin);
                  if (event.type == "display") showValue = true;
                  if (event.type == "geojson") showGeoJson = true;
                }
              }

              if (showGeoJson){
                if (event.geoJson == null){
                  /*event.kmlContent = fetch(event.geoJsonUri).then(res => res.text()).then(txt => {
                    const parser = new DOMParser();
                    event.geoJson = parser.parseFromString(txt, 'text/xml');
                    event.geoJson = L.geoJson(event.geoJson);
                    this.map.addLayer(event.geoJsonLayer);
                  });*/
                } else {
                  try{
                    evt.geoJsonLayer = L.geoJson(JSON.parse(event.geoJson));
                  }
                  catch (e) {
                    console.log(e);
                  }
                  this.map.addLayer(evt.geoJsonLayer);
                }
              } else if (event.geoJsonLayer){
                this.map.removeLater(evt.geoJsonLayer)
                evt.geoJsonLayer = null;
              }
            }
            index++;
          }
        }
      }

      var marker = this.staticsites[uri];
      if (this.staticsites[uri] == null){
        if(timeSeries == null || timeSeries.displayName == null|| timeSeries.displayName == "")
        {
          marker = L.marker([data.latitude, data.longitude],{icon:pin, title:data.name}).addTo(this.map);
        }
        else
        {
          marker = L.marker([data.latitude, data.longitude],{icon:pin, title:timeSeries.displayName}).addTo(this.map);
        }
         marker.on("mouseover", () => { });
         marker.on("mouseout", () => { });
        
        this.results.push(marker);
      }
      if (onClick) {
        marker.on('click', () => onClick(marker, timeSeries));      
      }

      //todo: ADD IN MORE EVENT TYPES HERE
      if (this.onHover != null) {
        marker.on("mouseover", () => { this.onHover.emit(uri); });
      }
      if (this.onUnhover != null) {
        marker.on("mouseout", () => { this.onUnhover.emit(uri); });
      }
        
      
      if (showValue){
        marker.bindTooltip("" + latest.value).openTooltip();
      }
      
      if (this.results.length > 0){
        this.resultGroup = L.featureGroup(this.results).addTo(this.map);
        this.dataGroup.addLayer(this.resultGroup);
        this.map.fitBounds(this.dataGroup.getBounds());
        if (zoom) this.map.setZoom(zoom);
      }

      this.staticsites[uri] = marker;
    }
  }

  private dataGroup : L.FeatureGroup = L.featureGroup();
  private results: L.Marker[] = [];
  private resultGroup: L.FeatureGroup;

  public showSearchResult(items: any[], onLoad, onSelect, fitBounds) {
    try {
      for (let item of items){
        if (item.latitude && item.longitude){
          const marker = L.marker([item.latitude, item.longitude],{icon:item.icon == null ? this.icons.pins.blue : item.icon});
          //marker.isV
          var popup = `<div><b>Site:</b>${item.siteName}<br/><b>Name:</b>${item.name}<br/><b>Site Type:</b>${item.siteType}<br/><b>Site Description:</b>${item.siteDescription}<br/><b>Description:</b>${item.description}<br/></div>`;
          marker.bindPopup(popup, {closeOnClick:true, closeButton: false, autoClose:true})
          if (onSelect != null){
            marker.on('contextmenu', () => onSelect(marker, item));
          }
          onLoad(marker, item);
          this.results.push(marker);
        }
      }
      if (this.results && this.results.length > 0){
        this.resultGroup = L.featureGroup(this.results).addTo(this.map);
        if (fitBounds == true){
          this.map.fitBounds(this.resultGroup.getBounds());
        }
      }
    }
    catch (ex) {
      console.warn("Failed to Load Result on Map", ex);
    }
  }

  public clearSearchResults(){
    if (this.results){
      for (let marker of this.results) {
        if (marker){
          marker.remove();
        }
      }
    }
    this.results = [];
  }
}

